<template>
    <div :class="classes" class="upload-drop">
        <form enctype="multipart/form-data" novalidate>
            <div class="upload-drop-box" tabindex="1" @keyup.enter="toggleUpload">
                <input
                    ref="upload"
                    :name="fieldName"
                    :disabled="isSaving"
                    :accept="accept"
                    type="file"
                    class="input-file"
                    @change="filesChange($event.target.name, $event.target.files)">

                <p v-if="isInitial">
                    Drag your file here to begin
                    <br>or click to browse
                </p>
                <p v-if="isSaving">Uploading file...</p>
                <p v-if="isFailed">Error uploading file. Please try again.</p>
            </div>
        </form>
    </div>
</template>

<script>
import axios from '../../network/axios'

const STATUS_INITIAL = 0,
    STATUS_SAVING = 1,
    STATUS_SUCCESS = 2,
    STATUS_FAILED = 3
export default {
    name: 'upload-drop',
    props: {
        url: String,
        fieldName: String,
        accept: {
            type: String,
            default: 'text/csv'
        },
        body: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            uploadedFiles: [],
            uploadError: null,
            currentStatus: null
        }
    },
    computed: {
        isInitial() {
            return this.currentStatus === STATUS_INITIAL
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED
        },
        classes() {
            return [{ error: this.isFailed }]
        }
    },
    mounted() {
        this.reset()
    },
    methods: {
        reset() {
            this.currentStatus = STATUS_INITIAL
            this.uploadedFile = null
            this.uploadError = null
        },

        upload(formData) {
            this.currentStatus = STATUS_SAVING
            axios.post(this.url, formData).then(({ data }) => {
                this.$emit('success', data)
            },
            error => {
                this.currentStatus = STATUS_FAILED
                this.uploadError = error
                this.$emit('error', error)
            })
        },

        filesChange(fieldName, files) {
            // handle file changes
            const formData = new FormData()
            if (files.length <= 0) return
            formData.append(fieldName, files[0], files[0].name)

            if (this.body) {
                for (const [key, value] of Object.entries(this.body)) {
                    formData.append(key, value)
                }
            }

            this.upload(formData)
        },

        toggleUpload() {
            this.$refs.upload.click()
        }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

.upload-drop
    background: $light-blue
    margin: 10px 0px
    padding: 10px
    border-radius: 5px

    &.error
        background: $light-red

        .upload-drop-box
            border-color: $darker-red
            color: $darker-red

    .upload-drop-box
        border: 2px dashed $darker-blue
        color: $darkest-blue
        padding: 10px 10px
        min-height: 150px
        position: relative
        cursor: pointer
        text-align: center
        display: flex
        align-items: center
        justify-content: center
        border-radius: 3px

        &:hover
            background: rgba(14, 111, 198, 0.05)
            outline-color: $darkest-blue

        &:drop
            background: rgba(14, 111, 198, 0.1)

        .input-file
            opacity: 0
            width: 100%
            height: 200px
            position: absolute
            cursor: pointer
</style>
